<header class="app-header">
  <div class="container header-inner">
    <div class="logo">
      <div class="logo-mark">MN</div>
      <div class="logo-text">
        <span class="logo-title">Murder Nights</span>
        <span class="logo-sub">Intriga en los años 20</span>
      </div>
    </div>

    <nav class="nav">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Presentación</a>
      <a routerLink="/comprar" routerLinkActive="active">Comprar</a>
    </nav>
  </div>
</header>

<main class="app-main">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</main>

<footer class="app-footer">
  <div class="container footer-inner">
    <span class="typewriter">© {{ currentYear }} Murder Nights. Misterio bajo la luz tenue.</span>
    <span class="footer-secondary">Juego creado por Adrian Navarro Benito.</span>
  </div>
</footer>
